/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

try {
  if( $('.OptionSelector_dd').length ){
    $('.OptionSelector_dd').change(function(){      
      if( $('#'+$(this).data('target')).length ){
        $('#'+$(this).data('target')).find('.Popover__ValueList .Popover__Value[data-value="'+ $(this).val() +'"]').trigger('click');
      }
    })
  }
  window.addEventListener("click",handleClick);  
  function handleClick(t){var e=t.target; e.hasAttribute("data-quickshop-btn")&&(t.preventDefault(),this.closeAllQuickshop(),this.openQuickshop(t)),null===e.closest('.ProductItem')&&this.closeAllQuickshop()}
  function openQuickshop(t){
    if ( (t.path[1]).querySelector('.product-card__quickshop').clientHeight > (t.path[1]).clientHeight ){ 
      console.log((t.path[1]).querySelector('.product-card__quickshop'));
     /* (t.path[1]).querySelector('.product-card__quickshop').style.height = ( (t.path[1]).clientHeight - 5)+'px'; */
    }
    t.target.previousElementSibling.classList.add('active')
  }
  function closeAllQuickshop(){document.querySelectorAll("[data-quickshop]").forEach(function(t){
    /*(t).querySelector('.product-card__quickshop').style.height = '';*/
    t.classList.remove('active')})}
  $(document).on('click','[data-quickshop-atc]:not([disabled])',function(){
    var variant_id = $(this).data('variant-id');
    var _this = $(this);
    _this.addClass('disabled');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json', 
      data: 'id='+variant_id+'&quantity=1',
      success: function(){
        /*$('#sidebar-cart').attr('aria-hidden','false');
        $('.PageOverlay').addClass('is-visible');
        $('html').addClass('no-scroll');*/
        _this.removeClass('disabled');
        $.ajax({
          type: 'GET', 
          url: '/cart?view=drawer',
          dataType: 'html', 
          success: function(responseTxt){
            var cartObj = JSON.parse($(responseTxt).attr('data-section-settings'));
            $( "#sidebar-cart" ).empty();
            $( "#sidebar-cart" ).attr('data-section-settings',$(responseTxt).attr('data-section-settings'));
            $( "#sidebar-cart" ).append($(responseTxt).html());
            $('.Icon-Wrapper--clickable[data-drawer-id="sidebar-cart"] .Header__CartDot').addClass('is-visible');
            $('[data-action="open-drawer"][data-drawer-id="sidebar-cart"] .Header__CartCount').text(cartObj.itemCount);            
          }
        });
      },
      error: function(){
      	_this.removeClass('disabled');
      }
    });
  });
  
  $(document).on('click','.grid_option label',function(){
    $(this).parent().find('input').prop('checked',true);
    $(this).parent().find('input').attr('checked','checked');
    $(this).closest('.sw__el').siblings().find('input').prop('checked',false);
    $(this).closest('.sw__el').siblings().find('input').removeAttr('checked','checked');
    var handle = '/products/'+$(this).closest('.product-card__swatch').data('handle')+'.js';    
    var _this = $(this);    
    var variant_title = '', addtocart_btn = _this.closest('.product-card__quickshop').find('.product-card__atc');
    _this.closest('.product-card__swatch').find('.grid_option').each(function(index){      
      if( $(this).find('input[checked]').length ){
        variant_title += index > 0 ? ' / '+$(this).find('input[checked]').val() : $(this).find('input[checked]').val();
      }
    });	
    if(variant_title){
      _this.closest('.product-card__quickshop').find('.main_select option').each(function(){
        if( variant_title == $(this).text().trim() ){          
          $(addtocart_btn).attr('data-variant-id', $(this).val());
          $(addtocart_btn).removeAttr('disabled');
          if( $(this).attr('data-available') == "false" ){            
            $(addtocart_btn).attr('disabled','disabled');
          }
        }
      });
    }
  });
  
  
  
  (function(){
    var proSection = document.querySelector('.Product');
    if( proSection != undefined || proSection.length > 0 ){
      var jsonData = JSON.parse(proSection.querySelector('[data-product-json]').innerHTML);    
      var productData = jsonData['product'],currentVariant ='',option1 ='',option2 ='',option3 ='';
      productData['variants'].forEach(function (variant) {
        if (variant['id'] === jsonData['selected_variant_id']) {
          currentVariant = variant;
          option1 = variant['option1'];
          option2 = variant['option2'];
          option3 = variant['option3'];
        }
      });    
      for( var i = 0; i < productData['options'].length; i++){ }
    }
  });
  
  
  document.querySelector('.product-type-slider' ).style.display = 'none';
  window.onload = function () {
      var colorSlider = document.querySelector('.product-type-slider' );
    console.log( colorSlider );
    if( colorSlider != undefined || colorSlider.length > 0 ){ colorSlider.style.display = 'block';
                                                             var flkty = new Flickity( colorSlider, {
                                                               pageDots: false,
                                                               prevNextButtons: true,
                                                               cellAlign: 'left',
                                                               contain: true
                                                             });
                                                            }
    
    
  };

} catch (e) {
  console.log("error",e);
}
